module.exports = "https://img.xiyuyouxi.com/saas/img/de_icon2.c1652abc.png";